import { render, staticRenderFns } from "./ServicosControleHoras.vue?vue&type=template&id=4aea5ff0&"
import script from "./ServicosControleHoras.vue?vue&type=script&lang=ts&"
export * from "./ServicosControleHoras.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports